import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f7a3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-location-page" }
const _hoisted_2 = { class: "operation" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map_location",
  class: "map"
}, null, -1))

import { ref, onMounted } from 'vue'
import {
  createPopup,
  createMap,
  getDeviceClass,
  formatLat,
  formatLng,
} from '@/utils/map.utils'
import { CODE_ENUM, DEVICE_STATUS_ENUM } from '@/common'
import { ElMessage } from 'element-plus'
import { querySiteTreelist, querySiteDistribution } from '@/api'
import MapControl from '@/components/map-control'
import moment from 'moment'
import i18n from '@/i18n'
import L from 'leaflet'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

// 已选设备
const selectSite = ref('')

// 设备下拉选项
const deviceChange = (value: any) => {
  querySiteLocation(value || '')
}

let map: any = null
onMounted(async () => {
  map = createMap('map_location')
  querySiteLocation()
})

// 设备列表
const siteList: any = ref([])
const querySiteLocation = async (siteId?: string) => {
  const res: any = await querySiteDistribution({
    siteId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    siteList.value = (res?.data || []).filter((item: any) => {
      return item.locationLat
    })

    createSiteMaker()
  }
}

const markerEntity: any = ref([])
// 移除设备
const clearAllMarker = () => {
  markerEntity.value.forEach((marker: any) => {
    marker.entity.remove()
  })
}

// 渲染设备
const createSiteMaker = () => {
  clearAllMarker()
  markerEntity.value = []
  siteList.value.forEach((site: any) => {
    const marker: any = createMarker(site)
    // 这里要存储一个产品类型
    markerEntity.value.push({
      id: site.id,
      entity: marker,
    })
  })

  if (siteList.value.length !== 0) {
    map.fitBounds(getPoints(siteList.value))
  } else {
    const latlng = new L.LatLng(22.646419, 114.090136)
    map.panTo(latlng)
    map.setView(latlng, 6)
    ElMessage.warning(t('SITE.noAddress'))
  }

  renderDevice()
}

// 渲染合适的entity -> 类型合适
const renderDevice = () => {
  clearAllMarker()
  markerEntity.value.forEach((marker: any) => {
    marker.entity.addTo(map)
  })
}

const createMarker = (site: any) => {
  const { locationLong, locationLat } = site

  const marker = L.marker([locationLat, locationLong], {
    icon: new L.divIcon({
      iconSize: [45, 63],
      className: 'ws_icon_site',
      iconAnchor: [23, 63],
    }),
  })
  const popup = createPopup(site)

  marker.bindPopup(popup)
  marker.off('click')
  marker.on('click', async (e: any) => {
    const { latlng } = e
    popup.setContent(`
      <div class="ws_mb4">${t('SITE.siteName')}：${site.name}</div>
      <div class="ws_mb4">${t('SITE.col2')}：${site.orgName || '-'}</div>
      <div class="ws_mb4">${t('SITE.address')}：${site.locationAddress}</div>
      <div class="ws_mb5">${t('SITE.desc')}：${site.describe || '-'}</div>
      <div class="ws_mb5 ws_site_online"><a href="#/site/site-list/site-detail?id=${
        site.id
      }&deviceStatusCode=${DEVICE_STATUS_ENUM.ONLINE}">${t('SITE.onlineTip', {
      text: site.onlineNumber || 0,
    })}<span>></span></a></div>
    <div class="ws_mb5 ws_site_unactive"><a href="#/site/site-list/site-detail?id=${
      site.id
    }&deviceStatusCode=${DEVICE_STATUS_ENUM.NOACTIVATE}">${t(
      'SITE.noActiveTip',
      { text: site.noActiveNumber || 0 }
    )}<span>></span></a></div>
      <div class="ws_mb4 ws_site_offline"><a href="#/site/site-list/site-detail?id=${
        site.id
      }&deviceStatusCode=${DEVICE_STATUS_ENUM.OFFLINE}">${t('SITE.offlineTip', {
      text: site.offlineNumber || 0,
    })}<span>></span></a></div>
    
    `)
    map.panTo(latlng)
    map.setView(latlng, 13)
    marker.openPopup()
  })

  return marker
}

// 获取点
const getPoints = (points: any) => {
  return points.map((site: any) => {
    const { locationLong, locationLat } = site
    return {
      lng: locationLong,
      lat: locationLat,
    }
  })
}

const siteTreeList: any = ref([])
const querySiteTreeList = async () => {
  const res: any = await querySiteTreelist()
  if (res?.code === CODE_ENUM.SUCCESS) {
    siteTreeList.value = res.data || []
  }
}
querySiteTreeList()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('SITE.siteName')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: selectSite.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectSite).value = $event)),
              onChange: deviceChange,
              clearable: "",
              filterable: "",
              style: {"width":"280px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siteTreeList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.name,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _hoisted_4,
    _createVNode(_unref(MapControl))
  ]))
}
}

})